export const responseBody = (res) => {
  if (!res) return {};
  if (res.data && (res.data.error || res.data.data || res.data.status)) {
    return res.data;
  }
  if (res.response && res.response.data) return res.response.data;
  return {};
};

export const errorText = (res) => {
  const error = responseBody(res).error;
  if (!error) return "Could not create this record.";
  if (typeof error === "string") return error;
  if (error.details) return error.details;
  const values = Object.keys(error).map((key) => error[key]);
  return (
    values
      .reduce((list, item) => list.concat(item), [])
      .filter((item) => typeof item === "string")
      .join(" ") || "Could not create this record."
  );
};

export const createResponseStatus = (res) => {
  if (!res) return 0;
  if (res.isAxiosError && res.response && res.response.status) {
    return Number(res.response.status);
  }
  if (res.status !== undefined && res.status !== null && res.status !== "") {
    const status = Number(res.status);
    if (Number.isFinite(status)) return status;
  }
  const nested = Number(responseBody(res).status);
  return Number.isFinite(nested) ? nested : 0;
};

export const isSuccessfulCreate = (res) => {
  if (!res || res.isAxiosError) return false;
  const status = createResponseStatus(res);
  if (!status || status < 200 || status >= 300) return false;
  const bodyStatus = Number(responseBody(res).status);
  if (Number.isFinite(bodyStatus) && bodyStatus >= 400) return false;
  return true;
};
